



export const showSliders = () => {

  const inneBlock = document.querySelectorAll(".program__inner");

  inneBlock.forEach(inner => {
    const buttonShowProgram = inner.querySelector(".program__show");
    const hiddenListProgram = inner.querySelector(".program__slider");
    const hiddenElementsProgram = inner.querySelectorAll(".program__card_hidden");
  
    if ( buttonShowProgram && hiddenListProgram ){
      buttonShowProgram.addEventListener('click', function () {
        //alert("hello");
  
        var listHeightProgram = 0;
  
        for (let i = 0; i < hiddenElementsProgram.length; i++ ){
          listHeightProgram = +listHeightProgram + +inner.querySelectorAll(".program__card_hidden")[i].offsetHeight + 20;
        }
    
        if ( !hiddenListProgram.classList.contains("program__slider_open") ){
          hiddenListProgram.classList.add("program__slider_open");
          buttonShowProgram.classList.add("program__show_open");
          buttonShowProgram.textContent = "Скрыть";
  
          hiddenListProgram.style.height = listHeightProgram + "px";
        } else {
  
          hiddenListProgram.classList.remove("program__slider_open");
          buttonShowProgram.classList.remove("program__show_open");
  
          hiddenListProgram.style.height = 0 + "px";
          buttonShowProgram.textContent = "Показать полностью";
  
        }
  
      });
    }
  });






  const buttonShowSpeakers = document.querySelector(".speakers__show");
  const hiddenListSpeakers = document.querySelector(".speakers__slider");
  const hiddenElementsSpeakers = document.querySelectorAll(".speakers__card_hidden");

  if ( buttonShowSpeakers && hiddenListSpeakers ){
    buttonShowSpeakers.addEventListener('click', function () {
      //alert("hello");

      let listHeightSpeakers = 0;

      for (let i = 0; i < hiddenElementsSpeakers.length; i++ ){
        listHeightSpeakers = +listHeightSpeakers + +document.querySelectorAll(".speakers__card_hidden")[i].offsetHeight + 20;
      }

  
      if ( !hiddenListSpeakers.classList.contains("speakers__slider_open") ){
        hiddenListSpeakers.classList.add("speakers__slider_open");
        buttonShowSpeakers.classList.add("speakers__show_open");

        hiddenListSpeakers.style.height = (listHeightSpeakers / hiddenElementsSpeakers.length * Math.ceil( hiddenElementsSpeakers.length / 3 )) + "px";
        
      } else {

        hiddenListSpeakers.classList.remove("speakers__slider_open");
        buttonShowSpeakers.classList.remove("speakers__show_open");

        hiddenListSpeakers.style.height = 0 + "px";
      }

    });
  }



  const buttonShowMore = document.querySelector(".speakers__more");
  const hiddenElementsMore = document.querySelectorAll(".speakers__p_hide");

  if ( buttonShowMore ){
    buttonShowMore.addEventListener('click', function () {

      

      for (let m = 0; m < hiddenElementsMore.length; m++) {

        if ( !hiddenElementsMore[m].classList.contains("speakers__p_show") ){
          console.log(1);
          hiddenElementsMore[m].classList.add("speakers__p_show");
          buttonShowMore.classList.add("speakers__more_open");
        } else {
          hiddenElementsMore[m].classList.remove("speakers__p_show");
          buttonShowMore.classList.remove("speakers__more_open");
        }
          
      }
  
    });
  }








  const burgerBtn = document.querySelector(".header__burger");
  const burgerMenu = document.querySelector(".header__menu");

  burgerBtn.addEventListener("click", function(){

    if ( !burgerBtn.classList.contains("header__burger_open") ){
      burgerBtn.classList.add("header__burger_open");
      burgerMenu.classList.add("header__menu_open");
    } else {
      burgerBtn.classList.remove("header__burger_open");
      burgerMenu.classList.remove("header__menu_open");
    }

  });
  


}